<article>
  <section>
    <app-badge-svg [badgeId]="badge.id" [activation]="activation()"> </app-badge-svg>

    <div class="info">
      <span> {{badge.title}} </span>
      <span> {{badge.description}} </span>
      <opac-tag *ngIf="badge.timesWon > 0">
        {{ (badge.timesWon > 1 ? 'gamification.badges.timesWon.plural' : 'gamification.badges.timesWon.singular') | translate: { timesWon: badge.timesWon } }}
      </opac-tag>
    </div>
  </section>

  <footer *ngIf="percentage() > 0 && percentage() < 100">
    <span>{{badge.progress}} / {{badge.goal}} {{unitTypeLabel() | translate}}</span>
    <opac-progress-bar [progress]="progressObject.percentage" progressText="%"> </opac-progress-bar>
  </footer>
</article>
